import { FC, useContext, useEffect } from "react";
import { useSearchParams } from "react-router";
import { useTranslation } from "react-i18next";

import { useAlert } from "capitalrx-components-2.0/lib/general";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";

import { AuthSources, StorageKeys } from "@/App/constants/constants";
import { AuthenticationContext } from "@/App/context";
import { useNavigateClient } from "@/App/hooks";
import { resolveEmulation } from "@/App/api/emulation";

export const EmulationCallbackPage: FC = () => {
  const { t: translate } = useTranslation();
  const [searchParams] = useSearchParams();
  const emulationId = searchParams.get("emulation_id");
  const { setAuthState } = useContext(AuthenticationContext);
  const navigate = useNavigateClient();
  const alert = useAlert();

  useEffect(() => {
    if (emulationId) {
      localStorage.removeItem(StorageKeys.ACCESS_TOKEN);
      localStorage.removeItem(StorageKeys.REFRESH_TOKEN);
      localStorage.removeItem(StorageKeys.AUTH_SOURCE);
      localStorage.removeItem(StorageKeys.PARENT_IDENTITY);

      resolveEmulation(emulationId)
        .then((response) => {
          const date = new Date();
          localStorage.setItem(StorageKeys.EMULATION_START, `${date}`);
          localStorage.setItem(StorageKeys.PARENT_IDENTITY, response.parent_identity);
          localStorage.setItem(StorageKeys.ACCESS_TOKEN, response.auth_token);
          localStorage.setItem(StorageKeys.REFRESH_TOKEN, response.refresh_token);
          localStorage.setItem(StorageKeys.AUTH_SOURCE, AuthSources.CAPITALRX_STS);
          sessionStorage.setItem("isEmulation", "true");
          setAuthState("signedIn");
          navigate("/");
        })
        .catch(() => {
          sessionStorage.setItem("isEmulation", "false");
          alert({
            message: translate("EMULATION_CALLBACK_PAGE.failedToResolveEmulation"),
            type: "error",
            style: "toast",
          });
          navigate("/login");
        });
    } else {
      navigate("/login");
    }
  }, [emulationId]);

  return <Paragraph textAlign="center">{translate("EMULATION_CALLBACK_PAGE.determiningEmulationSession")}</Paragraph>;
};
